// Import Olympe runtime or DRAW
import 'olympe';

// Import dependencies
import {Chart, registerables} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(...registerables, ChartDataLabels);

// Import project bricks (we use webpack-import-glob-loader to import all bricks)
import './common/deprecated/model/ChartsData.js'; import './common/deprecated/model/ChartsDataSet.js'; import './common/deprecated/ObjectToChartsData.js';
import './web/deprecated/Chart.js'; import './web/utils/CartesianConfig.js'; import './web/utils/chartjs-adapter-date-fns.js'; import './web/utils/PolarConfig.js'; import './web/utils/utils.js';
import './web/CartesianChart.jsx'; import './web/deprecated/Chart.jsx'; import './web/MapChart.jsx'; import './web/PolarChart.jsx'; import './web/SpeedometerChart.jsx';

// Export data types
export * from './web/utils/CartesianConfig';
export * from './web/utils/PolarConfig';
